module.exports = __webpack_public_path__ + "static/media/nodata.c273aa12.png";